const bpla = {
  hero: {
    title:
      'MADE IN UKRAINE. BATTLE-PROVEN. CERTIFIED BY THE MINISTRY OF DEFENCE.',
    description:
      'PEGASUS ARMS 25 is a next-generation Ukrainian strike quadcopter. Combat-tested, highly resistant to EW, with stable radio communication and telemetry. Co-designed by engineers and military specialists, the drone was officially approved for use by a Ministry of Defence order in January 2024. It is equipped with adaptive electronics and an autonomous return-to-base system which is activated in case of signal loss.',
    paragraphs: [
      'The primary mission of Pegasus Arms 25 is striking enemy armor, vehicles, and manpower. Besides, the UAV is used to neutralize engineering structures, perform remote mining, and do logistics. Pegasus Arms 25 is a versatile aerial vehicle that can do a lot of things. It can deliver equipment, ammunition, medical supplies, food, etc. You name it, Pegasus Arms 25  can do it!',
      'Modular architecture of Pegasus Arms 25 supports a wide range of its payload options:',
    ],
    cards: [
      'Anti-tank mines',
      'Engineering munitions (remote mining)',
      'WARHEAD MODULE FOR STRIKE MISSIONS',
      'Specialized delivery systems (medical supplies, water, ammunition)',
    ],
  },

  results: {
    title: 'COMBAT PERFORMANCE',
    paragraphs: [
    'In February 2024, the Pegasus Arms 25 strike UAV was used to destroy a Russian TOS-1A “Solntsepyok” heavy flamethrower system. But this was far from the only successful mission of this combat bird. Pegasus Arms 25 has proven its effectiveness in more than one hundred thousand successfully completed missions.',
    'Pegasus Arms 25 is a combat drone developed in Ukraine and field-tested at the frontline. Able to adapt to the needs of individual units, it features stable communication, EW resistance, and operational autonomy. More than 100 units of the Defence Forces use it to strike enemy equipment, fortifications, and manpower, increasing overall battlefield effectiveness.',
  ],
  },

  integration: {
    title: 'GOVERNMENT PLATFORMS',
    paragraphs: [
      'The Pegasus Arms 25 UAV / UAS is officially listed on the defence marketplace,',
      'where military units can order it within the “Army of Drones Bonus” program using awarded E-Points. Delivery and accounting are managed via the DOT-chain Defence.',
    ],
    link: 'Brave1Market.',
  },
}

export default bpla
